import {
  Routes, Route, Navigate, BrowserRouter,
} from 'react-router-dom'

import { Suspense } from 'react'
import FrontPage from '@page/front/FrontPage'
import OneWaySlabPage from '@page/one-way-slab/OneWaySlabPage'
import TwoWaySlabPage from '@page/two-way-slab/TwoWaySlabPage'
import BeamPage from '@page/beam/BeamPage'
import ColumnPage from '@page/column/ColumnPage'
import FoundationPage from '@page/foundation/FoundationPage'
import BasementWallPage from '@page/basement-wall/BasementWallPage'
import WindTunnelStudyPage from '@page/wind-tunnel-study/WindTunnelStudyPage'
import PageLayout from '@layout/PageLayout'
import Content from '@layout/Content'

function Router () {
  return (
    <BrowserRouter>
      <Suspense fallback={<Content />}>
        <Routes>
          <Route path="/" element={<FrontPage />} />
          <Route element={<PageLayout />}>
            <Route path="one-way-slab" element={<OneWaySlabPage />} />
            <Route path="two-way-slab" element={<TwoWaySlabPage />} />
            <Route path="beam" element={<BeamPage />} />
            <Route path="column" element={<ColumnPage />} />
            <Route path="foundation" element={<FoundationPage />} />
            <Route path="basement-wall" element={<BasementWallPage />} />
            <Route path="wind-tunnel-study" element={<WindTunnelStudyPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default Router
